import { Link } from 'react-router-dom';
import { BookOpen } from 'lucide-react';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { Seo } from '../components/Seo';
import { BLOG_POSTS } from '../lib/blogPosts';

export function BlogIndexPage() {
  return (
    <>
      <Seo
        path="/kennisbank"
        title="Kennisbank"
        description="Artikelen over koellast, vermogen, Comfort Basis en Plus, warmtepomp-keuzes en het ComfortTool™-rapport — met concrete vervolgstappen."
        keywords="ComfortTool kennisbank, koellast, vermogen, warmtepomp, rapport, scan"
      />
      <div className="mx-auto max-w-3xl px-4 py-10 sm:py-14">
        <Breadcrumbs items={[{ label: 'Home', to: '/' }, { label: 'Kennisbank' }]} />
        <header className="mt-6">
          <div className="inline-flex items-center gap-2 rounded-full border border-ct-border bg-ct-surface px-3 py-1 text-xs font-semibold text-ct-muted">
            <BookOpen className="h-3.5 w-3.5 text-ct-accent" aria-hidden />
            Kennisbank
          </div>
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-ct-text sm:text-4xl">
            Slimmer kiezen met ComfortTool™
          </h1>
          <p className="mt-4 text-pretty text-base leading-relaxed text-ct-muted sm:text-lg">
            Korte, praktische artikelen in gewone taal. Geen vervanging van maatwerk op locatie — wél een betere start.
          </p>
        </header>

        <ul className="mt-12 space-y-4">
          {[...BLOG_POSTS]
            .sort((a, b) => (a.datePublished < b.datePublished ? 1 : a.datePublished > b.datePublished ? -1 : 0))
            .map((p) => (
            <li key={p.slug}>
              <article className="rounded-2xl border border-ct-border bg-ct-surface/90 p-5 transition hover:border-ct-accent/30 hover:shadow-lg sm:p-6">
                <time className="text-xs font-medium text-ct-muted" dateTime={p.datePublished}>
                  {new Date(p.datePublished).toLocaleDateString('nl-NL', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric',
                  })}
                </time>
                <h2 className="mt-2 text-lg font-bold text-ct-text sm:text-xl">
                  <Link to={`/kennisbank/${p.slug}`} className="hover:text-ct-accent">
                    {p.title}
                  </Link>
                </h2>
                <p className="mt-2 text-sm leading-relaxed text-ct-muted">{p.description}</p>
                <Link
                  to={`/kennisbank/${p.slug}`}
                  className="mt-4 inline-flex text-sm font-semibold text-ct-accent hover:underline"
                >
                  Lees artikel →
                </Link>
              </article>
            </li>
          ))}
        </ul>

        <div className="mt-14 rounded-2xl border border-dashed border-ct-border bg-ct-elevated/30 p-6 text-center">
          <p className="text-sm text-ct-muted">Wil je direct aan de slag?</p>
          <Link
            to="/scan"
            className="mt-3 inline-flex rounded-xl bg-ct-accent px-6 py-3 text-sm font-bold text-white hover:bg-blue-500"
          >
            Start de scan
          </Link>
        </div>
      </div>
    </>
  );
}
